<style lang="scss" scoped></style>
<template>
  <div>
    <select
      :disabled="disabled"
      @change="$emit('input', vmodel)"
      class="form-control"
      :class="{ 'is-invalid': hasErrors, disabled: disabled }"
      v-model="vmodel"
    >
      <option v-if="nullable" :key="null" :value="null">{{
        attribute.nullValue
      }}</option>
      <option
        v-for="model in models"
        :key="model.id"
        :value="model[valueProperty]"
        >{{ model[resourceProperty] }}</option
      >
    </select>
    <div
      v-if="hasErrors"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      vmodel: null,
      models: []
    };
  },
  async created() {
    let filter = this.attribute.filter ? this.attribute.filter : [];
    const { data } = await this.$http.get(
      `/api/v1/${this.attribute.resource}`,
      { params: { filter: filter } }
    );
    this.models = data;
    this.vmodel = this.value;
  },
  props: ["attribute", "value", "disabled"],
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    resourceProperty() {
      return this.attribute.resourceProperty !== undefined
        ? this.attribute.resourceProperty
        : "name";
    },
    valueProperty() {
      return this.attribute.valueProperty !== undefined
        ? this.attribute.valueProperty
        : "id";
    },
    nullable() {
      return this.attribute.nullValue !== undefined;
    }
  }
};
</script>
